<template lang="pug">
v-row.uploadThemeFiles(justify="end")
  v-dialog(v-model='dialog' persistent='' max-width='600px')
    template(v-slot:activator='{ on, attrs }')
      v-btn(icon v-bind='attrs' v-on='on')
        v-icon mdi-pencil
    v-card
      v-toolbar(flat dark color="primary")
        v-toolbar-title.text-capitalize {{typeName}} hochladen
      v-card-text
        v-container
          v-alert(color='accent' dark v-if="error") {{error}} 
          v-row
            v-col(cols='12' max-height="150")
                //-upload-anything-zone
                v-file-input( v-model="file" show-size placeholder='Datei auswählen' prepend-icon='mdi-file' :label='typeName')

        small(v-if="typeName != 'musik'") *Das bisherige 
          span.text-capitalize {{typeName}} 
          | wird durch das Hochladen ersetzt
      v-card-actions
        v-spacer
        v-btn(color='primary' text=''  @click='dialog = false')
          | Abbrechen
        v-btn(color='primary' :disabled="uploading" :loading="uploading"  depressed @click='upload')
          | Hochladen

</template>

<script>
// import lambda from '@/services/lambda'
// import axios from "axios";
export default {
  name: "uploadThemeFiles",
  props: {
    uploadPath: String,
    typeName: String,
  },
  data: () => ({
    dialog: false,
    uploading: false,
    file: null,
    error: "",
    logoRules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Das Logo sollte kleiner als 2 MB sein!",
    ],
  }),
  methods: {
    upload() {
      this.uploading = true;
    },
  },
};
</script>

<style></style>
